import TreeListColumnProps from './Columns'

let KendoTreeListColumn = {
    name: 'kendo-treelist-column',
    render () {
        return null
    },
    mixins: [TreeListColumnProps]
}

export default KendoTreeListColumn


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeListColumn/index.js